import { Money } from '@dreryk/money-common-api';

import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';
import { InteractiveTable } from '@dreryk/react-components';

type ReceptionServiceInteractiveTableAdvancePaymentCellProps = {
   readonly advancePaymentValue: Money | undefined;
};

export const ReceptionServiceInteractiveTableAdvancePaymentCell = (
   props: ReceptionServiceInteractiveTableAdvancePaymentCellProps
): JSX.Element => {
   return (
      <InteractiveTable.Cell testId={'advancePayment'}>
         {props.advancePaymentValue
            ? priceFormatter(
                 props.advancePaymentValue.asNumber(),
                 getCustomFormattingContext({
                    options: {
                       currency: 'PLN',
                       stripDecimalZeroes: true,
                    },
                 })
              )
            : '-'}
      </InteractiveTable.Cell>
   );
};
